module.exports = __webpack_public_path__ + "static/img/business1_active.8eb621e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business1_active.png
// module id = U1Bn
// module chunks = 3